import {createAction} from "redux-act";
import {ITranslationsReducer} from "modules/types";

export const fetchTranslationsAction = createAction();
export const fetchTranslationsSuccessAction = createAction<ITranslationsReducer[]>();
